import { Fragment, useEffect, useState } from "react";
import { PendingOrderhistory } from "./pendingOrderhistory";
import { useParams } from "react-router-dom";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { PendingViewOrderDetails } from "./pendingViewOrderDetails";

export const MyPendingOrderMain = () => {
  const { orderId } = useParams();
  const [viewId, setViewId] = useState(null);
  const [breadCrumb, setBreadCrumb] = useState(null);
  useEffect(() => {
    if (orderId) {
      setViewId(orderId);
      setBreadCrumb([
        { name: "My Account", url: "/myaccount" },
        { name: "Pending Orders", url: "/myaccount/pending-orders" },
        { name: "View", url: "" },
      ]);
    } else {
      setViewId(null);
      setBreadCrumb([
        { name: "My Account", url: "/myaccount" },
        { name: "Pending Orders", url: "/myaccount/pending-orders" },
      ]);
    }
  }, [orderId]);
  return (
    <Fragment>
      <BreadCrumb data={breadCrumb} />
      <div className="fz-container">
        <div className={`css-fade fz-panel ${viewId ? "inactive" : "active"}`}>
          <PendingOrderhistory active={!viewId} />
        </div>

        <div className={`css-fade fz-panel ${viewId ? "active" : "inactive"}`} id="viewOrderDetails">
          <PendingViewOrderDetails orderId={viewId} />
        </div>
      </div>
    </Fragment>
  );
};
